import { createSlice } from '@reduxjs/toolkit';
import { normalizeProfileResponse } from '../../shared/profile';

const storedProfileInfo = localStorage.getItem('profileInfo')
	? normalizeProfileResponse(JSON.parse(localStorage.getItem('profileInfo')))
	: null;

export const UserProfile = createSlice({
	name: 'userProfile',
	initialState: {
		email: storedProfileInfo?.email ?? '',
		name: storedProfileInfo?.first_name ?? '',
		lastName: storedProfileInfo?.last_name ?? '',
		birthDate: storedProfileInfo?.birthday ?? '',
	},
	reducers: {
		fillProfileInfo: (state, actions) => {
			const normalized = normalizeProfileResponse(actions.payload);
			state.email = normalized.email;
			state.name = normalized.first_name;
			state.lastName = normalized.last_name;
			state.birthDate = normalized.birthday;
		},
		resetProfileInfo: state => {
			state.email = '';
			state.name = '';
			state.lastName = '';
			state.birthDate = '';
		},
	},
});

export const { fillProfileInfo, resetProfileInfo } = UserProfile.actions;

export default UserProfile.reducer;
